module.exports = __webpack_public_path__ + "static/media/expenses.614f540c.png";